import { parseQueryStatNumber } from "./queryBuilder";
import { scoreboardNameFromPlayer } from "./playerDisplayName";

export const buildWidgetTableRows = (players = [], maxRows = 10) =>
  players.slice(0, maxRows).map((player, index) => ({
    id: player.playerId || player.id || `row-${index}`,
    rank: player.rank ?? index + 1,
    playerId: player.playerId,
    playerName: scoreboardNameFromPlayer(player, "-"),
    value: parseQueryStatNumber(player.value),
    category: player.category,
  }));
